module.exports = __webpack_public_path__ + "img/746.4130e630.jpg";